(function () {
  var SECTION_SELECTOR = '.oddit-section-scrolling-text';
  var sectionState = new Map();
  var sectionCounter = 0;

  function initMarquee(section) {
    var track = section.querySelector('[data-marquee-track]');
    var firstSet = section.querySelector('[data-marquee-set]');
    if (!track || !firstSet) return null;

    var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    function measure() {
      var setWidth = firstSet.scrollWidth;
      var trackStyle = getComputedStyle(track);
      var trackGap = parseFloat(trackStyle.columnGap) || parseFloat(trackStyle.gap) || 0;
      var distance = setWidth + trackGap;
      track.style.setProperty('--marquee-distance', '-' + distance + 'px');
    }

    function enable() {
      measure();
      track.style.animationPlayState = 'running';
    }

    function disable() {
      track.style.animationPlayState = 'paused';
    }

    if (reducedMotion.matches) {
      disable();
    } else {
      enable();
    }

    var ro = new ResizeObserver(function () {
      if (!reducedMotion.matches) measure();
    });
    ro.observe(section);

    function handleReducedMotion(e) {
      if (e.matches) {
        disable();
      } else {
        enable();
      }
    }

    if (reducedMotion.addEventListener) {
      reducedMotion.addEventListener('change', handleReducedMotion);
    }

    function handleVisibility() {
      if (reducedMotion.matches) return;
      track.style.animationPlayState = document.hidden ? 'paused' : 'running';
    }

    document.addEventListener('visibilitychange', handleVisibility);

    return {
      ro: ro,
      reducedMotion: reducedMotion,
      handleReducedMotion: handleReducedMotion,
      handleVisibility: handleVisibility
    };
  }

  function destroyMarquee(state) {
    if (!state) return;
    if (state.ro) state.ro.disconnect();
    if (state.reducedMotion && state.reducedMotion.removeEventListener) {
      state.reducedMotion.removeEventListener('change', state.handleReducedMotion);
    }
    document.removeEventListener('visibilitychange', state.handleVisibility);
  }

  function getSectionKey(section) {
    if (section.id) return section.id;
    if (!section.dataset.odditMarqueeKey) {
      sectionCounter += 1;
      section.dataset.odditMarqueeKey = 'scrolling-text-' + sectionCounter;
    }
    return section.dataset.odditMarqueeKey;
  }

  function initSection(section) {
    var key = getSectionKey(section);
    if (sectionState.has(key)) return;
    var marqueeState = initMarquee(section);
    sectionState.set(key, { marquee: marqueeState });
  }

  function destroySection(section) {
    var key = getSectionKey(section);
    var state = sectionState.get(key);
    if (!state) return;
    destroyMarquee(state.marquee);
    sectionState.delete(key);
  }

  function initAll() {
    document.querySelectorAll(SECTION_SELECTOR).forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var section = e.target.querySelector(SECTION_SELECTOR);
    if (section) initSection(section);
  });

  document.addEventListener('shopify:section:unload', function (e) {
    var section = e.target.querySelector(SECTION_SELECTOR);
    if (section) destroySection(section);
  });
})();